import { contactsService } from './contacts/contacts';
import { contactCompanyService } from './contacts/company';
import { employeesService } from './employees/employees';
import { employeeScheduleService } from './employees/schedules';
import { employeePlanService } from './employees/plans';
import { employeeOverridesService } from './employees/overrides';
import { ibanService } from './iban';
import { acquisitionSourceService } from './acquisition_source';
import { serviceServices } from './services';
import { serviceGroupService } from './service_groups';
import { serviceCategoriesService } from './service_categories';
import { orderStatusesService } from './order_statuses';
import { ordersService } from './orders/orders';
import { chargesService } from './orders/charges';
import { orderEmployeeService } from './orders/employees';
import { invoicesService } from './orders/invoices';
import { paymentsService } from './orders/payments';
import { bookingsService } from './booking';
import { addressesService } from './address';
import { companiesService } from './companies/company';
import { viesService } from './companies/vies';
import { companyContactService } from './companies/contact';
import { tenantCompaniesService } from './companies/tenant';
import { clientConfigurationService } from './client_configuration';
import { erganiServices } from './ergani';
import { erganiEmployeeServices } from './erganiEmployees';
import { erganiScheduleServices } from './erganiSchedules';
import { erganiAttendanceServices } from './erganiAttendance';
import { leadsService } from './leads';
import { tenantsService } from './tenants/tenant';
import { communicationsService } from './communications';
import { branchesService } from './branches';
import { paymentMethodsService } from './paymentMethods';
import { invoicingSeriesService } from './invoicing_series';
import { fiscalProfileService } from './invoicing_fiscal_profile';
import { providerActivationService } from './invoicing_provider_activation';
import { adminTenantsService } from './admin/tenants';

// Define functions to call the endpoints
const apiService = {
  contacts: {
    ...contactsService,
    companies: { ...contactCompanyService },
  },
  employees: {
    ...employeesService,
    schedules: {
      ...employeeScheduleService,
      plans: { ...employeePlanService },
      overrides: { ...employeeOverridesService },
    },
  },
  ...ibanService,
  ...acquisitionSourceService,
  ...serviceServices,
  ...serviceGroupService,
  serviceCategories: {
    ...serviceCategoriesService,
  },
  ...orderStatusesService,
  orders: {
    ...ordersService,
    charges: { ...chargesService },
    employees: { ...orderEmployeeService },
    invoices: { ...invoicesService },
    payments: { ...paymentsService },
  },
  bookings: {
    ...bookingsService,
  },
  ergani: {
    ...erganiServices,
    ...erganiEmployeeServices,
    ...erganiScheduleServices,
    ...erganiAttendanceServices,
  },
  ...addressesService,
  companies: {
    ...companiesService,
    vies: { ...viesService },
    contacts: { ...companyContactService },
    tenant: { ...tenantCompaniesService },
  },
  clientConfiguration: {
    ...clientConfigurationService,
  },
  leads: {
    ...leadsService,
  },
  tenants: {
    ...tenantsService,
  },
  admin: {
    tenants: { ...adminTenantsService },
  },
  communications: {
    ...communicationsService,
  },
  branches: {
    ...branchesService,
  },
  paymentMethods: {
    ...paymentMethodsService,
  },
  invoicingSeries: {
    ...invoicingSeriesService,
  },
  fiscalProfile: {
    ...fiscalProfileService,
  },
  providerActivation: {
    ...providerActivationService,
  },
};

export default apiService;
